export default function MenuPage({ children }) {

    return (
        <ul className="menu-page">
            {children}
        </ul>
    );
}